<script>
import lazyLoadComponent from '@router/lazyload-component'
import BaseButtonDialog from '@components/BaseButtonDialog'

export default {
  components: {
    BaseButtonDialog,
    TagManagmentListItem: () => lazyLoadComponent(import('./TagManagmentListItem'))
  },
  data() {
    return {
      tagList: [],
      newTagTitle: '',
      tryAdd: false,
      show: this.dialogVisible,
      activeItemIndex: '',
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  computed: {
    isEmptyList() {
      return this.tagList.length
    }
  },
  watch: {
    dialogVisible: function () {
      this.show = this.dialogVisible
    },
  },
  methods: {
    async tryToFetchList() {
      try {
        this.tagList = await this.$store.dispatch('member/fetchTags', {
          search: '',
        })
      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 標籤管理 新增打API
     */
    async tryToAdd() {
      try {
        if (this.tryAdd) return
        this.tryAdd = true
        await this.$store.dispatch('member/storeTag', {
          title: this.newTagTitle,
        })
        this.tryAdd = false
        this.tryToFetchList()
      } catch (error) {
        console.error(error.message)
        
      } finally {
        this.tryAdd = false
      }

    },
    onAdd() {
      if (this.newTagTitle === '') {
        this.$message({
          message: '請輸入標籤名稱',
          type: 'warning',
        })
        return
      }
      this.tryToAdd()
    },
    onSave() {
      this.tryToRemove()
    },
    closeDialog() {
      this.$emit('update:dialogVisible', false)
      this.activeItemIndex = ''
    },
    updateActiveIndex(index) {
      this.activeItemIndex = index
    }
  },
}
</script>

<template>
  <BaseButtonDialog ref="dialog" :only-dialog="true" :title="'標籤管理'" :dialog-visible.sync="show" :destroy="true"
    :width="'36%'" floating @closed="closeDialog" @dialog-opened="tryToFetchList">
    <el-form class="el-form-item--normal-margin" @submit.prevent.native>
      <el-form-item class="px-2">
        <el-input v-model.trim="newTagTitle" placeholder="建立新標籤" clearable :class="$style.createInput"
          class="isStyleButton" @keydown.enter.prevent>
          <el-button slot="append" v-loading="tryAdd" type="primary" :class="$style.create" class="is-round"
            @click="onAdd">新增</el-button>
        </el-input>
      </el-form-item>
      <div :class="$style.list" class="px-2">
        <el-divider class="my-2"></el-divider>
        <transition-group v-if="isEmptyList" name="el-zoom-in-center">
          <template v-for="(tag, index) in tagList">
            <TagManagmentListItem :key="`tag-${tag.id}`" :default-value="tag" :item-index="index"
              :current-active-index="activeItemIndex" @update="updateActiveIndex" @refresh="tryToFetchList" />
          </template>
        </transition-group>
        <div v-else style="text-align: center;color: darkgray;line-height: 5em;">
          暫無資料顯示
        </div>
      </div>
    </el-form>
    <div class="py-2">
      <el-divider class="my-2"></el-divider>
      <p class="" style="color:#3F3A2E">提醒您：移除標籤不會移除具有標籤的該用戶</p>
    </div>
  </BaseButtonDialog>
</template>

<style lang="scss" module>

.alert {
  background-color: rgba($color-primary, 0.1) !important;
  color: $color-primary !important;
}

.list {
  overflow: auto;
  max-height: 30vh;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    display: block;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d8d8d8;
  }

  :global {
    .el-form-item {
      margin-bottom: 15px;
    }
  }
}
</style>
